import React from "react";
import pic1 from "../assets/Rectangle 4407.png";
import icon1 from "../assets/inventory.png";
import icon2 from "../assets/farmer.png";
import icon3 from "../assets/car.png";
import { rightArrow } from "../assets/right-arrow";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function services({ scrollRef }) {
  return (
    <div className="lg:h-fit lg:min-h-screen my-4 flex flex-col-reverse lg:flex-row justify-center gap-10 items-center p-6 lg:p-0">
      <div className="lg:w-[50%]">
        <motion.div
          ref={scrollRef}
          initial={{ opacity: 0 , y:-75 }}
          whileInView={{ opacity: 1, y:0 }}
          transition={{ duration: 0.6 }}
          viewport={{ root: scrollRef, once: true }}>
          <div className="justify-end lg:flex gap-1 lg:text-5xl font-bold hidden ">
            <span className="text-primary">الزراعــــيـــــة</span>
            <span>الخدمـــــات</span>
          </div>
          <div className="font-bold text-base lg:font-medium text-center mb-6  lg:text-right lg:my-7 lg:text-2xl px-6 lg:px-0">
            تساعد المنصة على عرض و طلب الخدمات المختلفى كالتخزين و النقل و
            العمالة اليومية و ما الى ذلك بطريقة سهلة و مباشره
          </div>
        </motion.div>
        <motion.div
          ref={scrollRef}
          initial={{ opacity: 0 , x:75 }}
          whileInView={{ opacity: 1, x:0 }}
          transition={{ duration: 0.6 }}
          viewport={{ root: scrollRef, once: true }}
           className="flex flex-col-reverse gap-10 w-full lg:flex-row justify-between lg:items-center">
          <Link to="/home/services">
            <div className="flex items-center w-full overflow-x-hidden gap-3 ">
              <div className="w-full h-[0.5px] bg-gray-400 lg:hidden"></div>

              <div className="p-2 bg-primary rounded-full ">{rightArrow}</div>
              <div className="w-full h-[0.5px] bg-gray-400 lg:hidden"></div>
            </div>
          </Link>
          <div className="lg:h-24 w-[1px] border border-gray-500 hidden lg:block"></div>
          <div className="flex justify-evenly lg:gap-10">
            <img
              src={icon1}
              alt=""
              className="w-[81.5px] h-[107px] lg:w-auto lg:h-auto"
            />
            <img
              src={icon2}
              alt=""
              className="w-[81.5px] h-[107px] lg:w-auto lg:h-auto"
            />
            <img
              src={icon3}
              alt=""
              className="w-[81.5px] h-[107px] lg:w-auto lg:h-auto"
            />
          </div>
        </motion.div>
      </div>
      <motion.div
        ref={scrollRef}
        initial={{ opacity: 0, y: 75 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ root: scrollRef, once: true }}
      >
        <img src={pic1} alt="" />
      </motion.div>
      <div className="flex gap-1 text-3xl font-bold lg:hidden ">
        <span className="text-primary">الزراعــــيـــــة</span>
        <span>الخدمـــــات</span>
      </div>
    </div>
  );
}

export default services;
